import { useState, useEffect, useCallback } from 'react';
import { getOperationalHealth } from '../services/BeholderService';

/**
 * Hook compartilhado para saúde operacional.
 * Retorna { health, loading, refresh } — refresh() recarrega manualmente.
 * pollInterval: ms entre recargas automáticas (0 = sem polling).
 */
export default function useOperationalHealth(pollInterval = 0) {
    const [health, setHealth] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(() => {
        setLoading(true);
        getOperationalHealth()
            .then(h => { setHealth(h); setLoading(false); })
            .catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        refresh();
        if (!pollInterval) return;
        const id = setInterval(refresh, pollInterval);
        return () => clearInterval(id);
    }, [refresh, pollInterval]);

    return { health, loading, refresh };
}
